import React from 'react'
import { Navigate, useParams } from 'react-router-dom'

/*
 * The old single-conversation page. Conversations now live in the Inbox
 * (Inbox.js + ChatThread.js); this keeps old links and bookmarks working.
 */
export default function ChatRoom() {
  const { roomUUID } = useParams()
  return <Navigate to={'/inbox/' + (roomUUID || '')} replace />
}
